import "./DevProjectionFormulaPage.css";
import { DashboardPage, createDashboardLayout } from "../components/DashboardPage/DashboardPage.jsx";
import { Panel } from "../components/Panel/Panel.jsx";
import { formatCurrency } from "../lib/formatters.js";
import {
  getProjectionFormulaProjectionState,
  getProjectionFormulaSelectionState,
  getBudgetCategoryLabel,
  ProjectionFormulaInspector
} from "../features/dev/ProjectionFormulaInspector.jsx";

const devProjectionFormulaPageLayout = createDashboardLayout({
  columns: [
    { size: "fill" }
  ],
  rows: [
    { size: "fill" }
  ],
  areas: [
    ["demo"]
  ]
});

export function DevProjectionFormulaPage({
  budgetRows = [],
  expenseRows = [],
  dateContext,
  t = (key) => key
}) {
  const { selectedBudgetRow } = getProjectionFormulaSelectionState(budgetRows);
  const { projection } = getProjectionFormulaProjectionState(expenseRows, selectedBudgetRow, dateContext);
  const selectedCategoryLabel = selectedBudgetRow ? getBudgetCategoryLabel(selectedBudgetRow) : "";

  return (
    <DashboardPage
      layout={devProjectionFormulaPageLayout}
      slots={[
        {
          key: "demo",
          area: "demo",
          fill: false,
          content: (
            <Panel
              padded
              className="dev-projection-formula-panel"
              header="Projection Formula"
              headerEnd={selectedCategoryLabel || null}
              footer="Ongoing rows only. Irregular rows are excluded from this view."
              footerEnd={projection ? formatCurrency(projection.projectedAnnualTotal) : null}
            >
              <ProjectionFormulaInspector
                budgetRows={budgetRows}
                expenseRows={expenseRows}
                dateContext={dateContext}
                t={t}
              />
            </Panel>
          )
        }
      ]}
    />
  );
}
